export default (domNode: HTMLElement) => {
  /**
   * Retrieve dataset value of the attrbute.
   */
  const htmlAttributeValue = domNode.dataset["faqScrollIntoView"] || "";

  /**
   * If html attribute has a value, then it must be a valid selector of another element we need to scroll to.
   * Else : if no value is provided we need to scroll to the dom node carrying the html attribute
   */
  const elementToScrollTo =
    htmlAttributeValue.length > 0
      ? (dom.querySelector(htmlAttributeValue) as HTMLElement)
      : domNode;

  let scrollTimeout: null | number = null;
  if (elementToScrollTo !== null) {
    const {
      width: elementWidth,
      left: elementPosX,
    } = elementToScrollTo.getBoundingClientRect();

    const elementIsNotEntirelyInViewport =
      elementWidth + elementPosX > window.innerWidth;

    if (elementIsNotEntirelyInViewport) {
      scrollTimeout = window.setTimeout(() => {
        elementToScrollTo.scrollIntoView({ behavior: "smooth" });
      }, 200);
    }
  }

  return function disposeCallback() {
    if (scrollTimeout !== null) {
      window.clearTimeout(scrollTimeout);
    }
  };
};
